module.exports = __webpack_public_path__ + "static/media/hermes.03a6acf2.svg";